import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const AvailableBankActivityProcessPayloadSchema = z.object({
    monthsOfBankData: z.number().optional(),
});

export class AvailableBankActivityProcessPayload extends FromSchema(AvailableBankActivityProcessPayloadSchema) {
    monthsOfBankData?: number;
}
